import React from 'react'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import useEnvironment from '../../../../../hooks/location/useEnviroment'
import PaginationButtons from '../../../../PaginationButtons'
import { ProviderResponse } from '../../../../../types/FHIRTypes/ProviderResponse'
import FhirLoader from '../../../../FhirLoader'

import { OrganizationTable } from '@teschglobal/tg-fhir-react-components'
import { Organization } from '@teschglobal/tg-fhir-react-components/dist/types'


type OrganizationListProps = {
    organizations: ProviderResponse<Organization>
    clickViewDataLink: (organization: Organization) => void
    isFetching: boolean
    isLoading: boolean
    isSuccess: boolean,
    searchProviderResource: { searchTerms: string, resource: string }
    clearForm: () => void
    newSearch: () => void
    updateSearchTerms: (e: React.ChangeEvent<HTMLInputElement>) => void
    totalPages: number;
    currentPage: number;
    handleChangePage: (page: number) => void;
}

const OrganizationList: React.FC<OrganizationListProps> = ({ organizations, clickViewDataLink, isFetching, isLoading, isSuccess, searchProviderResource, clearForm, newSearch, updateSearchTerms, totalPages, currentPage, handleChangePage }) => {
    const { data: environment } = useEnvironment()
    const rows: Organization[] = organizations?.data ?? []

    const handleNewSearch = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        newSearch()
    }


    return (
        <>
            <h3>Organization</h3>
            <Form noValidate className="d-flex align-items-center" onSubmit={handleNewSearch} role='form' aria-label='Search Organizations'>
                <Form.Group controlId="searchOrganization" className="d-flex align-items-center me-3 mb-0">
                    <Form.Label htmlFor="searchOrganization" className="mb-0 me-2 text-nowrap">
                        Search by Organization Name
                    </Form.Label>
                    <Form.Control
                        id="searchOrganization"
                        type="text"
                        name="keyword"
                        placeholder="Name"
                        value={searchProviderResource.searchTerms}
                        onChange={updateSearchTerms}
                    />
                </Form.Group>

                <Button variant="primary" className="btn-primary-custom" type="submit" id="searchButton">
                    Search
                </Button>
                <Button variant="primary-outline" type="reset" onClick={clearForm} id="clearButton">
                    Clear
                </Button>
            </Form>
            <hr />
            {(isLoading || isFetching) ? (
                <FhirLoader message='Loading...' />
            ) : (
                <>
                    {
                        organizations?.total > 0 && environment?.includeTotalInFHIRRequest && (
                            <div className='my-3 fw-bold'>
                                <span role="status" aria-live="polite">{organizations?.total.toLocaleString()} record(s) found</span>
                                <PaginationButtons
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                    handleChangePage={handleChangePage}
                                />
                            </div>
                        )
                    }

                    <OrganizationTable organizations={rows} onRowLinkClick={clickViewDataLink} />

                    {
                        organizations?.total > 0 && environment?.includeTotalInFHIRRequest && (
                            <div className='my-3 fw-bold'>
                                <PaginationButtons
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                    handleChangePage={handleChangePage}
                                />
                            </div>
                        )
                    }
                </>
            )}
        </>
    )
}

export default OrganizationList